module.exports = __webpack_public_path__ + "img/carmela.00a0f6c.jpeg";